<template>
    <icon-base v-bind="$props">
        <path
            d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6"
        />
        <path d="M11 13l9 -9" />
        <path d="M15 4h5v5" />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
